
import './ButtonScroll.css'

export default function Button({ children, targetId }) {
  const handleClick = () => {
    const section = document.getElementById(targetId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <button className='botaoScroll' onClick={handleClick}>
      {children}
    </button>
  );
}